import SearchBar from "@/components/searchbar";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { ArrowLeft } from "lucide-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const ChangePaymentPassword = () => {
  const form = useForm({
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
  });
  const navigate = useNavigate();
  const onSubmit = (data) => {};

  return (
    <div>
      {/* header */}
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="bg-primary-50 hover:bg-primary-50/90 flex size-8 items-center justify-center rounded-md"
          >
            <ArrowLeft className="size-6" />
          </button>
          <span className="hidden lg:inline">Change Payment Password</span>
        </div>

        <SearchBar />
      </header>

      <div className="mt-6">
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="mx-auto mt-8 max-w-100"
        >
          <Form {...form}>
            <FormField
              control={form.control}
              name="paymentPassword"
              render={({ field }) => (
                <FormItem className="mt-6 flex flex-col items-center lg:items-start">
                  <FormLabel>Enter Payment Password</FormLabel>
                  <FormControl>
                    <div className="flex justify-between">
                      <InputOTP className={""} maxLength={6} {...field}>
                        <InputOTPGroup
                          className={
                            "mt-2 w-full justify-between gap-3 text-center *:size-14"
                          }
                        >
                          <InputOTPSlot index={0} />
                          <InputOTPSlot index={1} />
                          <InputOTPSlot index={2} />
                          <InputOTPSlot index={3} />
                          <InputOTPSlot index={4} />
                          <InputOTPSlot index={5} />
                        </InputOTPGroup>
                      </InputOTP>
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit" className={"mt-6 w-full"}>
              Next
            </Button>
          </Form>
        </form>
      </div>
    </div>
  );
};

export default ChangePaymentPassword;
